import request from '@/utils/request'

let BalanceaApi = {
    /*余额设置*/
    setBalance(data) {
        return request._post('/shop/user.balance/setting', data);
    },
    /*获取设置*/
    getBalance(data) {
        return request._get('/shop/user.balance/setting', data);
    },
 
}
export default BalanceaApi;



// WEBPACK FOOTER //
// ./src/api/balancea.js